import React from 'react';
import { FadeIn } from './FadeIn';
export function Identity() {
  return <section id="identidad" className="py-32 md:py-48 px-6 md:px-12 bg-navy-light border-t border-steel" data-id="element-63" data-mp="lprbqin8g0bk">
      <div className="max-w-7xl mx-auto" data-id="element-64" data-mp="zpiu0vks82vd">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-24" data-id="element-65" data-mp="zqbw3j8sq476">
          <div className="lg:col-span-4 flex flex-col" data-id="element-66" data-mp="uq6bgn0y1hyl">
            <FadeIn data-id="element-67" data-mp="usinkjk0sy3q">
              <span className="text-[11px] font-semibold tracking-[0.2em] uppercase text-muted mb-6 block" data-id="element-68" data-mp="18pyyo8d9hg1t">
                01 — Identidad
              </span>
              <h2 className="font-display text-4xl md:text-5xl text-cream leading-[1.05]" data-id="element-69" data-mp="14odee1yedzhl">
                Conocimiento sin fronteras, al alcance de todos.
              </h2>
            </FadeIn>
          </div>

          <div className="lg:col-span-8 lg:col-start-5 space-y-8 text-muted font-light text-lg md:text-xl leading-relaxed" data-id="element-70" data-mp="1dj0f4kt49nni">
            <FadeIn delay={0.2} data-id="element-71" data-mp="1nfd8tionw1i9">
              <p data-id="element-72" data-mp="1ng65trxtjcn7">
                BPF LLC es una compañía de venta de libros digitales establecida
                en Wyoming, Estados Unidos. Operamos de forma 100% online, sin
                venta física ni sede física, lo que nos permite llegar a
                lectores en cualquier rincón del mundo.
              </p>
            </FadeIn>
            <FadeIn delay={0.3} data-id="element-73" data-mp="2dzuhxcnt94bo">
              <p data-id="element-74" data-mp="2ix466ozgr9xx">
                Somos especialistas en el armado de funnels Low Ticket a través
                de Meta Ads, una metodología que nos permite acercar contenido
                de alto valor a precios verdaderamente accesibles, sin
                sacrificar calidad editorial.
              </p>
            </FadeIn>
            <FadeIn delay={0.4} data-id="element-75" data-mp="2xms8ntjdsen8">
              <p data-id="element-76" data-mp="2xnux7ut8e4zz">
                Nuestra misión es clara: democratizar el conocimiento. Creemos
                que la información práctica y transformadora no debería estar
                reservada a unos pocos. Por eso construimos productos digitales
                que combinan rigor, claridad y un precio justo.
              </p>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}